import React from "react";
import ReportImage from "../../assets/final-images/homepage/lung 3D.jpg";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import MRIMachine from "../../assets/final-images/homepage/aquilionprimeSP_317_CO.JPG.jpg";
import DoneIcon from "@mui/icons-material/Done";
import Logo1 from "../../assets/final-images/homepage/Logos/1.png";
import Logo2 from "../../assets/final-images/homepage/Logos/2.png";
import Logo3 from "../../assets/final-images/homepage/Logos/3.png";
import Logo4 from "../../assets/final-images/homepage/Logos/4.png";
import HospitalImage from "../../assets/final-images/homepage/CDCHospital.jpg";
import abstruct from "../../assets/final-images/shapes/abstruct_2.png";
import shape from "../../assets/final-images/shapes/4-01.png";
import scanImage from "../../assets/final-images/homepage/scan-1.png";
import imaging_acc_1 from "../../assets/final-images/homepage/imaging-accreditation/radsite.png";
import imaging_acc_2 from "../../assets/final-images/homepage/imaging-accreditation/imaging-accreditation-02.png";
import imaging_acc_3 from "../../assets/final-images/homepage/imaging-accreditation/imaging-accreditation-03.png";
import imaging_acc_4 from "../../assets/final-images/homepage/imaging-accreditation/imaging-accreditation-04.png";
import imaging_acc_5 from "../../assets/final-images/homepage/imaging-accreditation/imaging-accreditation-05.png";
import { Link } from "react-router-dom";
import Faqs from "../Faqs";
export default function HomeSec2() {
  const faqs = [
    {
      question: "What is Citrus Diagnostic Center and where is it located?",
      answer:
        "Citrus Diagnostic Center is a physician-owned, radiologist-operated outpatient medical imaging center located in Crystal River, Florida, proudly serving Citrus County and the surrounding Nature Coast communities. Founded in the 1980s by a local radiologist, we offer a full range of diagnostic imaging services, including MRI, CT scan, X-rays, ultrasound, nuclear medicine, DEXA bone density scanning, and mammography-all under one roof, without the cost or complexity of a hospital visit.",
    },
    {
      question:
        "Do I need a referral to get imaging done at Citrus Diagnostic Center?",
      answer:
        "Yes, a physician's order is required for diagnostic imaging studies. However, we work seamlessly with referring physicians throughout Citrus County and the greater Nature Coast region. If your primary care doctor, specialist, or urgent care provider has ordered imaging, simply call us, and we will help you schedule your appointment quickly.",
    },
    {
      question:
        "How is Citrus Diagnostic Center different from hospital-based imaging?",
      answer:
        "As a physician-owned, independent outpatient imaging center, Citrus Diagnostic Center typically offers significantly lower out-of-pocket costs compared to hospital outpatient departments for the same imaging studies. You also benefit from shorter wait times, more personalized attention, convenient scheduling - often same day or next day - and results interpreted by a board-certified radiologist with deep roots in the local community. We are not a large hospital system; we are your neighbors.",
    },
    {
      question: "What insurance plans does Citrus Diagnostic Center accept?",
      answer:
        "Citrus Diagnostic Center accepts most major commercial insurance plans. We serve a predominantly commercially insured patient population and work to maximize your benefits. We recommend calling our office prior to your appointment so our team can verify your specific coverage and explain any estimated out-of-pocket costs before your visit.",
    },
    {
      question:
        "How long has Citrus Diagnostic Center been serving the Crystal River area?",
      answer:
        "Citrus Diagnostic Center has been serving the Crystal River and Citrus County community since the 1980s. Founded and operated by local radiologists, our practice has provided high-quality diagnostic imaging to generations of patients and families on Florida's Nature Coast. Our long-standing relationships with local physicians and our deep community ties set us apart from national imaging chains and hospital systems.",
    },
  ];
  return (
    <div>
      <div
        style={{
          background:
            "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
        }}
      >
        <div
          className="flex justify-center w-full items-center bg-center "
          style={{
            background: `url(${abstruct})`,
            backgroundSize: "100% 100%",
          }}
        >
          <div
            className="xl:w-[90%] mx-auto w-[95%]  backdrop-blur-xl rounded-xl my-14"
            style={{
              background: "linear-gradient(#ffffff0d 0%, #ffffff14 100%)",
            }}
          >
            <div className="grid xl:grid-cols-2 grid-cols-1 gap-5 xl:gap-20 justify-center items-center  px-5 xl:px-24 lg:py-10 pt-10 pb-5 ">
              <div className="text-center xl:text-left">
                <h1 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading capitalize ">
                  Citrus Diagnostic Center
                </h1>
                <p className="text-[#cccccc]  leading-[1.4em] font-medium pb-5 font-robout">
                  Independent. Radiologist-Led. Built for Diagnostic Excellence.
                </p>
              </div>
              <div className="text-white  ">
                <div className="text-[#cccccc]  leading-[1.4em] font-medium my-3 font-robout">
                  <p className="py-2">
                    Advanced medical imaging is a medical specialty-not a
                    commodity.
                  </p>
                  <p className="py-2">
                    At Citrus Diagnostic Center, every study is{" "}
                    <span className="font-extrabold">
                      guided by board-certified, fellowship-trained radiologists
                    </span>
                    , supported by academic-grade technology, and delivered with
                    a single focus:
                    <span className="font-extrabold">
                      {" "}
                      diagnostic clarity that puts patients first.
                    </span>
                  </p>
                  <p className="py-2">
                    Serving Citrus County for over three decades, Citrus
                    Diagnostic Center remains{" "}
                    <span className="font-extrabold">
                      radiologist-owned and operated
                    </span>
                    , free from corporate or treatment-driven influence-so
                    imaging decisions stay clinical, objective, and
                    evidence-based.
                  </p>
                </div>
              </div>
            </div>

            {/* Accrediation Section Will Be Here */}
            <div className=" text-center flex justify-center items-center  flex-col xl:gap-10 2xl:gap-2 gap-2 lg:pt-0  text-[#f5f5f5] ">
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 lg:gap-10 justify-items-center items-start px-4 sm:px-6 lg:px-10 py-8">
                {[
                  { img: imaging_acc_2, title: "CT", alt: "Accredited for CT" },
                  { img: imaging_acc_3, title: "MAMMOGRAPHY", alt: "Accredited for MAMMOGRAPHY" },
                  { img: imaging_acc_1, title: "MRI", alt: "Accredited for MRI" },
                  { img: imaging_acc_4, title: "NUCLEAR MEDICINE", alt: "Accredited for NUCLEAR MEDICINE" },
                  { img: imaging_acc_5, title: "PET", alt: "Accredited for PET" },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="flex flex-col items-center justify-center text-center gap-2 sm:gap-3"
                  >
                    <img
                      src={item.img}
                      alt={item.alt}
                      className="w-20 sm:w-24 md:w-28 lg:w-32 object-contain"
                    />

                    <p className="font-heading text-[14px] sm:text-[16px] md:text-[18px] lg:text-[20px] leading-snug text-[#cccccc]">
                      {item.title}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="xl:w-[90%] mx-auto py-10 xl:py-24 ">
        <div className="text-center">
          <h2 className="lg:text-[52px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading  capitalize  px-2 md:px-0 pb-5 ">
            Imaging That Guides Confident Care
          </h2>
          <div className="text-[#cccccc] font-robout   leading-[1.4em] font-medium text-center p-5 md:p-0 md:w-[50%] mx-auto">
            <p>
              We combine{" "}
              <span className="font-extrabold">
                expert interpretation, modern imaging platforms
              </span>
              , and
              <span className="font-extrabold">
                {" "}
                patient-centered design
              </span>{" "}
              to deliver imaging that physicians trust and patients feel
              confident choosing.
            </p>
            <p>
              This is imaging designed to answer real clinical
              questions-accurately, safely, and thoughtfully.
            </p>
          </div>
        </div>
        <div className="grid xl:grid-cols-2 grid-cols-1 gap-8 my-5 xl:my-20 p-5 xl:p-24 bg-[#0f0f0f] w-[90%] xl:w-full mx-auto rounded-xl">
          <div className="flex flex-col justify-center items-left">
            <h3 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal ">
              Not All Imaging Is the Same
            </h3>
            <p className="text-[#cccccc] font-robout  leading-[1.4em] font-normal">
              In medical imaging, protocols matter.
            </p>
            <p className="text-[#cccccc] font-robout  leading-[1.4em] font-medium pt-5 pb-3 ">
              At Citrus Diagnostic Center:
            </p>
            <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 ">
              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Imaging protocols are radiologist-designed</span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>
                  Studies are interpreted by subspecialty-trained physicians
                </span>
              </li>

              <li className="flex items-start gap-2">
                <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                <span>Reports are clear, consistent, and defensible</span>
              </li>
            </ul>
          </div>
          <div className="overflow-hidden  rounded-xl">
            <img src={ReportImage} alt="lung cancer and screening" className="w-full h-auto" />
          </div>
        </div>
        <div className=" text-[#cccccc] flex flex-col xl:flex-row gap-3 justify-center items-center capitalize">
          <p className="xl:text-[32px] text-[20px] ">Experience matters.</p>
          <p className="xl:text-[32px] text-[20px]">Independence matters. </p>
          <p className="xl:text-[32px] text-[20px]"> Patients matter.</p>
        </div>
      </div>
      <div
        style={{
          background:
            "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%, #330a16 100%)",
        }}
      >
        <div className="xl:w-[90%] mx-auto pb-10">
          <section className="relative xl:h-screen h-full flex justify-center items-center flex-col overflow-hidden">
            {/* Background Image */}
            <div
              className="absolute inset-0 bg-center bg-no-repeat bg-contain opacity-45"
              style={{
                backgroundImage: `url(${shape})`,
              }}
            ></div>

            {/* Grid Content */}
            <div
              className="
      relative z-10 
      grid xl:grid-cols-2 grid-cols-1 xl:gap-8 
      justify-center items-center 
     xl:px-10 py-12 rounded-lg 
      backdrop-blur-[10px]
    bg-[linear-gradient(#ffffff0d_0%,#ffffff14_100%)]
      border border-[#ffffff49]
      shadow-lg
     w-[90%] xl:w-full 3xl:w-[80%]
     xl:my-0 my-10
    "
            >
              {/* LEFT */}
              <div>
                <h2 className="lg:text-[38px] text-[24px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading text-center xl:text-left capitalize">
                  why radiologist-owned matters
                </h2>
                <p className="text-[#cccccc] leading-[1.4em] font-medium pb-5 font-robout xl:text-left text-center">
                  Not Corporate. Not Private Equity.
                </p>
              </div>

              {/* RIGHT */}
              <div>
                <div className="my-3 w-[90%] xl:w-[80%] mx-auto">
                  <p className="py-2 text-[#cccccc] leading-[1.4em] font-medium">
                    When imaging centers are owned by large corporations or
                    private equity firms, decisions may prioritize volume and
                    margins.
                  </p>

                  <p className="text-[#cccccc] leading-[1.4em] font-medium mt-4 pb-3">
                    At Citrus Diagnostic Center:
                  </p>

                  <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2">
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                      <span>Clinical quality comes first</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                      <span>Radiologists control protocols</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                      <span>
                        Technology investments are made for patient benefit
                      </span>
                    </li>
                    <li className="flex items-start gap-2">
                      <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                      <span>
                        Long-term community trust matters more than quarterly
                        returns
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div className="flex justify-center items-center">
              <img
                src={MRIMachine}
                alt="CT scan in Citrus Diagnostice center"
                className="rounded-xl w-full h-auto"
              />
            </div>
          </section>
        </div>
      </div>

      <div className="xl:w-[90%] mx-auto py-10 xl:py-24 ">
        <div className="text-center">
          <h2 className=" lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal  capitalize  px-2 xl:px-0">
            Patient Choice & Empowerment
          </h2>
          <div className=" w-[90%] md:w-[60%] mx-auto pb-3">
            <p className="  text-[#cccccc] font-normal   ">
              Your Health. Your Choice.
            </p>
            <p className="text-[#cccccc] mt-2 font-medium">
              Patients have the right to choose where their imaging is
              performed.
            </p>
          </div>
        </div>
        <div className="grid xl:grid-cols-2 grid-cols-1 gap-5 md:gap-20 3xl:w-[70%] mx-auto p-3 md:p-16">
          <div className=" px-5 md:px-0">
            <p className="text-[#cccccc]   leading-[1.4em] font-medium  ">
              We believe informed patients:
            </p>
            <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2 mt-3">
              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon
                  className="text-[#bf9c5e] mt-[2px]"
                  fontSize="small"
                />
                <span>Ask better questions</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon
                  className="text-[#bf9c5e] mt-[2px]"
                  fontSize="small"
                />
                <span>Receive better care</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon
                  className="text-[#bf9c5e] mt-[2px]"
                  fontSize="small"
                />
                <span>Achieve better outcomes</span>
              </li>
            </ul>
          </div>
          <div className=" px-5 md:px-0">
            <p className="text-[#cccccc]   leading-[1.4em] font-medium   ">
              We proudly support patient education using trusted resources:
            </p>
            <ul className="text-[#cccccc] leading-[1.4em] font-robout font-medium space-y-2 mt-3">
              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon
                  className="text-[#bf9c5e] mt-[2px]"
                  fontSize="small"
                />
                <span>RadiologyInfo.org</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon
                  className="text-[#bf9c5e] mt-[2px]"
                  fontSize="small"
                />
                <span>American College of Radiology (ACR)</span>
              </li>

              <li className="flex items-start gap-2">
                <KeyboardArrowRightIcon
                  className="text-[#bf9c5e] mt-[2px]"
                  fontSize="small"
                />
                <span>Image Wisely® and Image Gently®</span>
              </li>
            </ul>
          </div>
        </div>
        <div className=" w-[90%] my-10 mx-auto ">
          <div className="block md:flex justify-center items-center gap-10  bg-black border rounded-xl border-[#1f1f1f] p-10">
            <div>
              <img src={Logo3} alt="radiology info" className="bg-white my-4 md:my-0" />
            </div>
            <div>
              <img src={Logo4} alt="american college of radiology" className="bg-white my-4 md:my-0" />
            </div>
            <div>
              <img src={Logo2} alt="image-visely" className="bg-white my-4 md:my-0" />
            </div>
            <div>
              <img src={Logo1} alt="image-gently" className="bg-white my-4 md:my-0" />
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          background:
            "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
        }}
      >
        <div className="xl:w-[90%] mx-auto py-10 xl:py-24 ">
          <div className="grid xl:grid-cols-2 grid-cols-1 gap-0 xl:gap-20 justify-center items-center w-[90%] xl:w-full mx-auto p-8  xl:p-24 bg-[#0f0f0f] rounded-xl">
            <div>
              <h2 className=" lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal  capitalize ">
                For Referring Providers
              </h2>
              <p className="text-[#cccccc] leading-[1.4em] font-medium pb-5">
                Built for Physicians.
              </p>
            </div>
            <div className="  ">
              <div className="">
                <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2 mt-4">
                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                    <span>ACR Appropriateness Criteria–aligned protocols</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                    <span>Subspecialty-trained radiologists</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                    <span>Consistent, high-quality reporting</span>
                  </li>

                  <li className="flex items-start gap-2">
                    <DoneIcon className="mt-[2px] text-[#bf9c5e]" />
                    <span>Collaborative communication</span>
                  </li>
                </ul>
                <p className="text-[#cccccc]   leading-[1.4em] font-medium py-5 pt-5  ">
                  We exist to support-not replace-your clinical judgment.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="xl:w-[90%] mx-auto py-10 xl:py-24 ">
        <div>
          <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal  capitalize  px-2 xl:px-0  text-center">
            Built on Legacy . Focused on the Future
          </h2>
          <div className="grid xl:grid-cols-2 grid-cols-1 items-stretch xl:gap-8 my-5 xl:my-20 p-5 xl:p-24 w-[90%] xl:w-full mx-auto bg-[#0f0f0f] rounded-xl">
            {/* Text column */}
            <div className="w-[90%] flex items-center">
              <div className="text-[#cccccc]   leading-[1.4em] font-medium ">
                <p>
                  Citrus Diagnostic Center was shaped by decades of
                  physician-led imaging, beginning with early regional adoption
                  of CT, MRI, PET, and cardiac nuclear medicine under the
                  leadership of Kamalesh Amin, MD.
                </p>

                <p className="py-5">
                  Today, that legacy continues under Samir Amin, MD, combining
                  established expertise with modern imaging technology, digital
                  innovation, and a continued commitment to independent,
                  radiologist-led care.
                </p>
              </div>
            </div>

            {/* Image column */}
            <div className=" flex items-center justify-center">
              <img
                src={HospitalImage}
                alt="Citrus Diagnostic center in Florida"
                className="rounded-xl max-h-full object-cover"
              />
            </div>
          </div>

          <div className="  text-[#cccccc] flex flex-col xl:flex-row gap-3 justify-center items-center capitalize">
            <p className="xl:text-[32px] text-[20px] "> Quietly consistent.</p>
            <p className="xl:text-[32px] text-[20px] ">
              Intentionally advanced.{" "}
            </p>
          </div>
        </div>
      </div>
      <div
        style={{
          background:
            "linear-gradient(to right, #3d0e26 0%, #8b5e3c 50%,  #330a16 100%)",
        }}
        className="py-10 xl:py-24"
      >
        <div className="relative xl:w-[90%] mx-auto pb-10 xl:py-40 xl:px-16 bg-[#0f0f0f] rounded-xl overflow-hidden">
          {/* Background Image */}
          <img
            src={scanImage} // replace with your image variable
            alt="PET-T scans"
            className="absolute inset-0 w-full h-full object-cover opacity-55 pointer-events-none z-0"
          />

          {/* Content */}
          <div className="relative z-10 grid xl:grid-cols-2 grid-cols-1 xl:gap-16 gap-y-10 xl:gap-y-0 bg-[#000]/40 rounded-xl px-16 py-10 xl:px-10 xl:py-16 backdrop-blur-sm">
            {/* LEFT SIDE */}
            <div className="">
              <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading text-left capitalize ">
                Independent, Radiologist-Led Imaging
              </h2>

              <p className="font-heading text-[#cccccc] font-normal">
                Focused on diagnostic clarity.
              </p>

              <p className="pt-4 pb-3">Citrus Diagnostic Center is:</p>

              <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                <li className="flex items-start gap-2">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Radiologist-owned and operated</span>
                </li>

                <li className="flex items-start gap-2">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Referral-based</span>
                </li>

                <li className="flex items-start gap-2">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Independent of treatment delivery</span>
                </li>
              </ul>

              <p className="pt-4 pb-3">
                This structure allows imaging decisions to remain:
              </p>

              <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                <li className="flex items-start gap-2">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Clinically driven</span>
                </li>

                <li className="flex items-start gap-2">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Evidence-based</span>
                </li>

                <li className="flex items-start gap-2">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Focused solely on diagnostic accuracy</span>
                </li>
              </ul>

              <p className="py-3">
                Our role is to support patients and care teams with{" "}
                <span className="font-extrabold">
                  objective, high-quality imaging
                </span>
                , without competing interests.
              </p>
            </div>

            {/* RIGHT SIDE */}
            <div className="">
              <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading text-left capitalize ">
                Patient Choice in Advanced Imaging
              </h2>

              <p className="font-heading text-[#cccccc] font-normal">
                An informed decision matters.
              </p>

              <p className="pt-4 pb-3">Patients have the right to ask:</p>

              <ul className="text-[#cccccc] font-robout leading-[1.4em] font-medium space-y-2">
                <li className="flex items-start gap-2">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Where their imaging is performed</span>
                </li>

                <li className="flex items-start gap-2">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>Who interprets their studies</span>
                </li>

                <li className="flex items-start gap-2">
                  <DoneIcon className="mt-[2px] text-[#bf9c5e] shrink-0" />
                  <span>
                    Whether subspecialty imaging expertise is available
                  </span>
                </li>
              </ul>

              <p className="py-3">
                We encourage open discussion between patients and their care
                teams to choose the imaging setting that best aligns with their
                needs.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="lg:w-[80%] w-[90%] mx-auto lg:pt-24 lg:pb-20 py-14 ">
        <Faqs faqs={faqs} />
      </div>
      <div className="w-[90%] mx-auto">
        <div className="flex justify-center items-center">
          <div
            style={{
              background: `
                      linear-gradient(90deg,
                    #3d0e26 0%,
                    #5a1f33 1%,
                    #8b5e3c 40%,
                    #8b5e3c 70%,
                    #5a1f33 95%,
                    #330a16 100%
                  )
                    `,
            }}
            className="flex justify-center items-center xl:w-[668px] flex-col gap-2 py-8 px-6 xl:px-8 rounded-xl "
          >
            <h2 className="lg:text-[32px] text-[20px] leading-[1.4em] text-[#f5f5f5] font-normal font-heading texc  capitalize  ">
              Get Started with Confidence
            </h2>
            <p className="text-[#cccccc]   leading-[1.4em] font-medium text-center pb-5 px-4">
              Whether you’re a patient seeking clarity or a provider seeking a
              trusted imaging partner, Citrus Diagnostic Center is here to help.
            </p>

            <div className=" pb-5">
              <Link
                data-aos="fade-up"
                to="/contact-us"
                aria-label="Schedule Now"
                className="px-8 py-2.5 rounded-3xl bg-white text-black font-bold text-[17px] hover:bg-black hover:border hover:text-white border border-[#ffffff5d] transition-all duration-300"
              >
                Schedule Now
              </Link>
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-center items-center">
        <div className="w-11/12 xl:w-4/5  md:my-16 my-8">
          <iframe
            title="Citrus Diagnostic Center Florida"
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d6985.813095337112!2d-82.591563!3d28.901124999999997!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e841badd2a4091%3A0xeb4dead7dc4f5402!2sCitrus%20Diagnostic%20Center!5e0!3m2!1sen!2sin!4v1760678219616!5m2!1sen!2sin"
            className="w-full md:h-[450px] h-[300px]"
            height=""
            width="100%"
            allowFullScreen="true`"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>

        </div>{" "}
      </div>
    </div>
  );
}
